'use strict'
import { request } from '../../plugins/http'

export default async (factoryLanguageId) => {
    return await request.delete('/empresa_idioma', {params:{factoryLanguageId}})
}